<template>
  <v-row>
    <confirm-box
      :dialog="dialog"
      @confirmed="deleteItem"
      @cancel="dialog = false"
    />
    <v-col lg="12">
      <v-card class="card--shadow">
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="datas"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            :loading="loading"
            :page.sync="page"
            item-key="id"
            hide-default-footer
            hide-default-header
          >
            <template v-slot:header="{ props: { headers } }">
              <thead class="header">
                <tr>
                  <th
                    v-for="header in headers"
                    :key="header.text"
                    class="header--text"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </thead>
            </template>

            <template v-slot:item="{ index, item }">
              <tr>
                <td>{{ index + 1 }}</td>
                <td>{{ item.month }}</td>
                <td>{{ item.year }}</td>
                <td>{{ item.in_person }}</td>
                <td>{{ item.phone }}</td>
                <td>{{ item.absent }}</td>
                <td>
                  <span v-if="item.status == 1">Stop</span>
                  <span v-else-if="item.status == 2">On-going</span>
                </td>
                <td>{{ item.volunteer.name }} ({{ item.volunteer.code }})</td>
                <td>
                  <span v-if="index + 1 === datas.length && item.status == 2">
                    <v-btn
                      @click="openConfrimBox(item)"
                      icon
                      color="red lighten-1"
                      class="white--text"
                      depressed
                    >
                      <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>
                  </span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import ConfirmBox from "@/components/notification/ConfirmBox";

export default {
  props: ["datas"],
  components: {
    ConfirmBox,
  },
  data: () => ({
    dialog: false,
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    dataList: [
      {
        date: "2020-02-02",
        status: 1,
        month: 1,
        year: 2020,
      },
    ],
    headers: [
      { text: "No", value: "no" },
      { text: "Month", value: "month" },
      { text: "Year", value: "year" },
      { text: "In Person (days)", value: "in_person" },
      { text: "Phone (days)", value: "phone" },
      { text: "Absent (days)", value: "absent" },
      { text: "Status", value: "status" },
      { text: "Volunteer", value: "volunteer" },
      { text: "Actions", value: "actions" },
    ],
  }),
  methods: {
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deleteItem() {
      this.$store.dispatch("VisitReport/delete", {
        id: this.item.id,
      });
      this.dialog = !this.dialog;
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
  },
};
</script>

<style></style>
